import React, { Component } from "react";
import {
    Row,
    Col,
    Table
} from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import moment from "moment";
import { getFullName } from "../../helpers/functions/employee";

class TardinessReport extends Component {

    render() {

        const { reportData, startDate, endDate } = this.props;

        return (
            <Row>
              <div style={{
                marginTop: '60px'
              }}></div>
              <Col md={12}>
                <Card
                  title="Tardiness Report"
                  category={moment(startDate).format('MM/DD/YYYY') + " - " + moment(endDate).format('MM/DD/YYYY') }
                  ctTableFullWidth
                  ctTableResponsive
                  content={
                    <Table 
                      hover 
                      responsive 
                      striped
                    >
                      <thead>
                        <tr>
                          <th>Names</th>
                          {reportData && reportData.length > 0 && Object.keys(reportData[0]["entries"]).sort(function(a, b) {
                                return moment(a, 'YYYY/MM/DD').toDate() - moment(b, 'YYYY/MM/DD').toDate();
                          }).map(key=>{
                            return <th key={key}>{moment(key).format('DD')}</th>
                          })}
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {reportData && reportData.length > 0 
                          ? reportData.map((employee) => {
                            return (
                              <tr key={employee.employee._id}>
                                <td>{getFullName(employee.employee)}</td>
                                {Object.keys(employee.entries).sort(function(a, b) {
                                      return moment(a, 'YYYY/MM/DD').toDate() - moment(b, 'YYYY/MM/DD').toDate();
                                }).map(key=>{
                                  return <td key={key}>{Math.ceil(Math.abs(employee.entries[key]))}</td>
                                })}
                                <td>{Math.ceil(Math.abs(employee.totalMinutes))}</td>
                              </tr>
                            )
                          })
                          : (
                            <tr>
                              <td colSpan='4'>No results found.</td>
                            </tr>
                          )
                        }
                      </tbody>
                    </Table>
                  }
                />
              </Col>
            </Row>
        )
    }
}

export default TardinessReport;
